import React from 'react';
import { useCommon } from 'src/domains/common/Common';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';
import { CustomColumnsLayout } from 'src/domains/sportsbook/webview/components/eventMarkets/marketGroup/outrightMarket/CustomColumnsLayout';
import { EventRowGolfSelectionsWrapper } from 'src/domains/sportsbook/webview/components/sportEventsListNew/SportCompetitionsList/golf/EventRowGolf.style';
import { observer } from 'src/utils/mobx-react';
import { EventId, MarketId } from 'src_common/common/websocket2/id/WebsocketId';
import { SelectionModel } from 'src_common/common/websocket2/models/SelectionModel/SelectionModel';
import { sortSelectionsByCriteria } from 'src_common/utils/sport/sort';

interface GolfSelectionsPropsType {
    smallEventId: EventId;
    marketId?: MarketId;
    isOutrights?: boolean;
    className?: string;
}

const getMarket = (smallEventId: EventId) => {
    const markets = smallEventId.getEventMarkets();
    return markets?.length
        ? markets.reduce((min, current) => (current.displayOrder < min.displayOrder ? current : min)).id2.getModel()
        : null;
};

export const GolfSelections = observer('GolfSelections', (props: GolfSelectionsPropsType): JSX.Element | null => {
    const common = useCommon();
    const { smallEventId, marketId = null, isOutrights = false, className } = props;

    const market = marketId === null ? getMarket(smallEventId) : marketId.getModel();

    if (market === null) {
        return null;
    }
    const selections: Record<string, SelectionModel[]> = {};
    const displayOrder = market.displayOrderTag;
    const order = displayOrder !== undefined && displayOrder !== '-' ? displayOrder : 'by-creation';
    const marketSelections = market.selections.filter((s) => market.displayed && s.display);
    selections[market.id] = sortSelectionsByCriteria(marketSelections, order);
    const page = StarRouter.get(common).currentView?.name;

    const isEventPage = page === 'event';
    const isExpandable = isEventPage || (page === 'competition' && isOutrights);

    return (selections[market.id]?.length ?? 0) > 0 ? (
        <EventRowGolfSelectionsWrapper className={className}>
            <CustomColumnsLayout
                selections={selections}
                displayTemplate={isEventPage ? market.displayTemplate ?? '' : 'three-column'}
                rowsLimit={3}
                expandable={isExpandable}
                showParticipantName
            />
        </EventRowGolfSelectionsWrapper>
    ) : null;
});
